import { useContext } from "react";
import PerspectivesContext from "../contexts/PerspectivesContext";
const useActivePerspective = () => {
  const perspectivesContextValue = useContext(PerspectivesContext);
  if (!perspectivesContextValue) {
    throw new Error("useActivePerspective hook needs to be used inside PerspectivesContext.Provider");
  }
  return {
    activePerspective: perspectivesContextValue.activePerspective,
    setActivePerspective: perspectivesContextValue.setActivePerspective
  };
};
export default useActivePerspective;
